import { action } from 'satcheljs';
import { AttachmentFolderPickerProperties } from '../types/AttachmentFolderPickerProperties';
import { datapoints } from '../datapoints';
import { FolderSelectorResult } from 'owa-fileprovider-folder-selector';

/**
 * Folder selector modal actions
 */
export const openAttachmentFolderPicker = action(
    'openAttachmentFolderPicker',
    (properties: AttachmentFolderPickerProperties) => ({
        properties,
        datapointConfig: datapoints.AttFolderPickerOpened,
    })
);

export const closeAttachmentFolderPicker = action('closeAttachmentFolderPicker');

export const locationChanged = action('uploadLocationChanged', (result: FolderSelectorResult) => ({
    result,
}));

export const loading = action('loadingAttachmentFolderPicker');

export const stoppedLoading = action('stoppedLoadingAttachmentFolderPicker');

export const loadingAttachmentFolderFailed = action('loadingAttachmentFolderFailed');
